<template>
  <v-dialog :value="true" max-width="450px" :hide-overlay="true" :persistent="true">
    <v-card>
      <v-card-title class="headline">{{ $t('connect-by-code') }}</v-card-title>
      <v-card-text>
        <div v-if="step === 1">
          <p>{{ $t('connect-by-code-description') }}</p>

          <v-text-field
            autofocus
            v-model="fields.email"
            @keydown.enter.prevent="next()"
            :label="$t('field.email')"
            required>
          </v-text-field>
        </div>
        <div v-else>
          <p>{{ $t('type-code-description') }}<code>{{ fields.email }}</code></p>

          <v-text-field
            :label="$t('field.code')"
            v-model="fields.code"
            @keydown.enter.prevent="next()"
            required>
          </v-text-field>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-btn color="grey" text @click="cancel()">{{ $t('action.cancel') }}</v-btn>
        <v-spacer></v-spacer>
        <v-btn v-if="step === 1" color="blue darken-1" text :loading="$api.loading('account/password/reset')" @click="next()">
          {{ $t('action.continue') }}
        </v-btn>
        <v-btn v-else color="blue darken-1" text :loading="$api.loading('account/tokens/generate')" @click="next()">
          {{ $t('action.connect') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'AForgotPasswordWidget',
  data () {
    return {
      step: 1,
      fields: {
        email: '',
        code: '',
      },
    }
  },
  methods: {
    async next () {
      if(this.step === 1) {
        await this.$recaptchaLoaded()
        await this.$api.post('account/password/reset', {
          email: this.fields.email,
          _passive_client_token: await this.$recaptcha("password_reset")
        })
        this.step = 2
      }
      else {
        await this.$recaptchaLoaded()
        await this.$account.authenticate({
          email: this.fields.email,
          code: this.fields.code,
          _passive_client_token: await this.$recaptcha("login_code")
        })

        this.visible = false
        this.$ui.success('Connexion réussie, vous pouvez maintenant changer votre mot de passe.')
        await this.$router.push({ name: 'account_profile' })
      }
    },
    cancel () {
      if(this.step === 2) this.step = 1
      else this.$router.push({ name: 'login' })
    }
  },
  mounted () {
    if(process.env.VUE_APP_DEFAULT_EMAIL) this.fields.email = process.env.VUE_APP_DEFAULT_EMAIL
  }
}
</script>

<i18n>
{
	"en": {
		"action": {
			"cancel": "Annuler",
			"connect": "Connexion",
			"continue": "Continuer"
		},
		"connect-by-code": "Connect by code",
		"connect-by-code-description": "If your email is valid, a temporary code will be sent to you.",
		"field": {
			"code": "Temporary code",
			"email": "E-mail"
		},
		"type-code-description": "Enter the temporary code received on your email address below"
	},
	"es": {
		"action": {
			"cancel": "Anular",
			"connect": "acceder",
			"continue": "seguir"
		},
		"connect-by-code": "Iniciar sesión por código",
		"connect-by-code-description": "Si su correo electrónico es válido, se le enviará un código temporal para que pueda conectarse.",
		"field": {
			"code": "Código de acceso",
			"email": "e-mail"
		},
		"type-code-description": "Ingrese el código de conexión recibido en su dirección de correo electrónico a continuación"
	},
	"fr": {
		"action": {
			"cancel": "Annuler",
			"connect": "Connexion",
			"continue": "Continuer"
		},
		"connect-by-code": "Connexion par code",
		"connect-by-code-description": "Si votre email est valide, un code temporaire vous sera envoyé afin de vous permettre de vous connecter.",
		"field": {
			"code": "Code de connexion",
			"email": "Email"
		},
		"type-code-description": "Saisissez ci-dessous le code de connexion reçu sur votre adresse email"
	},
	"it": {
		"action": {
			"cancel": "Annulla",
			"connect": "Accedi",
			"continue": "Continua"
		},
		"connect-by-code": "Accedi con codice",
		"connect-by-code-description": "Se la tua email è valida, ti verrà inviato un codice temporaneo.",
		"field": {
			"code": "Codice temporaneo",
			"email": "Email"
		},
		"type-code-description": "Inserisci il codice temporaneo ricevuto al tuo indirizzo email qui sotto"
	},
	"pt": {
		"action": {
			"cancel": "Cancelar",
			"connect": "Iniciar sessão",
			"continue": "Continuar"
		},
		"connect-by-code": "Iniciar sessão por código",
		"connect-by-code-description": "Se o seu email for válido, ser-lhe-á enviado um código temporário.",
		"field": {
			"code": "Código temporário",
			"email": "Email"
		},
		"type-code-description": "Introduza abaixo o código temporário recebido no seu endereço de email"
	},
	"pl": {
		"action": {
			"cancel": "Anuluj",
			"connect": "Zaloguj się",
			"continue": "Kontynuuj"
		},
		"connect-by-code": "Zaloguj się kodem",
		"connect-by-code-description": "Jeśli Twój email jest prawidłowy, zostanie do Ciebie wysłany tymczasowy kod.",
		"field": {
			"code": "Tymczasowy kod",
			"email": "E-mail"
		},
		"type-code-description": "Wprowadź poniżej tymczasowy kod otrzymany na swój adres email"
	}
}
</i18n>
